import { ComponentInstance } from "@vue/composition-api";

const useInitCheckStatusesLib = (root: ComponentInstance): Promise<unknown[]> => {
  const store = root.$store;
  return Promise.all([store.dispatch("TKListView/getStatuses"), store.dispatch("TKListView/getTKTypes")]);
};

export default useInitCheckStatusesLib;
